module.exports = __webpack_public_path__ + "static/media/covid-mobile-en.e363a54a.jpg";